'use client';

import { usePathname } from 'next/navigation';

import { CallToAction } from '@/app/_componentsv2/call-to-action';
import Routes from '@/lib/router/routes';

export function AnonymousNavigation() {
  const pathname = usePathname();

  const searchParams =
    pathname !== Routes.Home
      ? `?${new URLSearchParams({ origin: pathname }).toString()}`
      : '';

  return (
    <>
      <CallToAction
        label="S'inscrire"
        type="next"
        href={`${Routes.SignUpRegister}${searchParams}`}
        hasArrow={false}
      />
      <CallToAction
        label="Se connecter"
        type="next"
        href={`${Routes.SignIn}${searchParams}`}
        hasArrow={false}
      />
    </>
  );
}
